import React from "react";

function StoryContent() {
  return (
  <div className="story__content">
    <h3 className="heading-3">New Rollers...elated</h3>
    <h2 className="heading-2 heading-2--dark mb-sm">&ldquo;The best decision of our lives&rdquo;</h2>
    <p className="story__text mb-sm">We were needing to get off the grid ASAP. With everything that's been happening, leaving it all and packing up has been a huge process. But not only did Rolling Real Estate give us the van of our dreams, they gave us the insanely high-value 50-hour comprehensive hands-on auto maintenance and builder schooling essentials schooling to successfully maintain our nomadic lives away from the grid. </p>
    <button className="btn">Build your van</button>
  </div>
  );
}

export default StoryContent; 